import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { remove } from "lodash";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";

import LectureContent from "../../models/lecture-content.model";
import { LectureContentService } from "../../services/lecture-content.service";
import { DialogImagesUploadComponent } from "../dialog-images-upload/dialog-images-upload.component";

@Component({
  selector: "ngx-dialog-lecture-content",
  templateUrl: "dialog-lecture-content.component.html",
  styleUrls: ["dialog-lecture-content.component.scss"],
})
export class DialogLectureContentComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() mode: string;
  @Input() lecture: LectureContent = new LectureContent();

  status: string = "0";
  trees: Set<string> = new Set([]);
  diaForm: FormGroup;
  submitted = false;
  loading = false;
  edited = false;
  imageURL = "";
  imagesUrl = [];
  menu = "info";

  //validate content
  bkContent = "";
  user: User;
  uid = "";

  constructor(
    public userService: UserService,
    protected ref: NbDialogRef<DialogLectureContentComponent>,
    private fb: FormBuilder,
    private lectureService: LectureContentService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    private router: Router
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
        } else {
          this.uid = "";
        }
      });

    const titleValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
    ];

    const descriptionValidators = [
      Validators.minLength(3),
      Validators.maxLength(500),
      Validators.required,
    ];

    this.diaForm = this.fb.group({
      title: ["", titleValidators],
      description: ["", descriptionValidators],
    });

    if (this.lecture.tags && this.lecture.tags.length > 0) {
      var trees = new Set([]);
      this.lecture.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("Kinh nghiệm");
    }

    if (!this.lecture.sourceType || this.lecture.sourceType == "") {
      this.lecture.sourceType = "document";
    }
    if (!this.lecture.status) {
      this.status = "0";
    } else {
      this.status = this.lecture.status.toString();
    }

    if (this.lecture.coverUrl && this.lecture.coverUrl != "") {
      this.imageURL = this.lecture.coverUrl;
    }
    if (this.lecture.imagesUrl && this.lecture.imagesUrl.length > 0) {
      this.imagesUrl = _.clone(this.lecture.imagesUrl);
    }
    if (!this.lecture.content) {
      this.lecture.content = "";
    } else {
      this.bkContent = this.lecture.content;
    }

    if (this.lecture.privacy == null || this.lecture.privacy == undefined) {
      this.lecture.privacy = false;
    }
    if (
      this.lecture.newComment == null ||
      this.lecture.newComment == undefined
    ) {
      this.lecture.newComment = true;
    }
    if (
      this.lecture.showComments == null ||
      this.lecture.showComments == undefined
    ) {
      this.lecture.showComments = true;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.lecture);
    } else {
      this.ref.close();
    }
  }

  selectMenu(value) {
    this.menu = value;
  }

  submit() {
    this.submitted = true;

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.lecture.tags = tags;
    this.lecture.status = parseInt(this.status);
    if (!this.user.admin && !this.user.moderator) {
      this.lecture.privacy = false;
      this.lecture.newComment = false;
      this.lecture.showComments = false;
    }

    if (this.mode == "edit") {
      this.edit();
    } else {
      this.create();
    }
  }

  create() {
    this.loading = true;
    this.submitted = true;

    this.lectureService
      .create(this.lecture)
      .then((data) => {
        this.lecture = data;

        this.loading = false;
        this.submitted = false;

        this.ref.close(this.lecture);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  edit() {
    this.loading = true;
    this.submitted = true;

    var subscribe: any;
    if (this.lecture.content != this.bkContent) {
      subscribe = this.lectureService.update(this.lecture);
    } else {
      subscribe = this.lectureService.updateInfo(this.lecture);
    }
    subscribe
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        this.edited = true;
        this.bkContent = this.lecture.content;
        this.showToast("success", "Cập nhật bài viết", "thành công");
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Cập nhật bài viết", "thất bại");
      });
  }

  //Images
  openGallery() {
    this.dialogService
      .open(DialogImagesUploadComponent, {
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.addImage(value);
        }
      });
  }

  updateImage(imageUrl) {
    if (imageUrl && imageUrl != "") {
      this.lecture.coverUrl = imageUrl;
      this.imageURL = imageUrl.replace("_400x400", "");
    }
  }
  removeCoverUrl() {
    this.lecture.coverUrl = "";
    this.imageURL =
      "https://kasoft-learning.s3.ap-southeast-1.amazonaws.com/assets/images/image-upload-bg.jpg";
  }

  addImage(obj) {
    let imageURL = obj.value;

    if (!this.lecture.imagesUrl) {
      this.lecture.imagesUrl = [];
    }
    this.lecture.imagesUrl.push(imageURL);

    if (obj.isNew) {
      imageURL = imageURL.replace("_400x400", "");
    }
    this.imagesUrl.push(imageURL);
  }

  deleteImage(item) {
    remove(this.lecture.imagesUrl, (el) => {
      return el == item;
    });
    remove(this.imagesUrl, (el) => {
      return el == item;
    });
  }

  navigateRef(item) {
    if (item.courseId != "") {
      this.router.navigateByUrl(`/tutor/course/${item.courseId}`);
      this.ref.close();
    }
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value.trim().toUpperCase());
    }
    input.nativeElement.value = "";
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
